import { Skeleton } from '@/components/sui/skeleton'

export function SearchDialogSkeleton({ rowCount = 3 }: { rowCount?: number }) {
  return (
    <div className="p-1">
      {Array.from({ length: rowCount }).map((_, i) => (
        <div key={i} className="flex items-center gap-2 px-2 py-3">
          <Skeleton className="h-5 w-5 rounded" />
          <Skeleton className="h-4 w-40" />
        </div>
      ))}
    </div>
  )
}
